<template>
	<div>
		<span>审批流程：</span>
		<div class="col" v-for="(item,index) in list" :key="index">
			<div class="row">
				<i class="el-icon-user"/>
				<span style="margin-right: 20px;">{{item.node_name}}：{{item.node_admin_name}}</span>
				<span style="margin-right: 20px;">创建时间：{{item.audit_time}}</span>
				<span v-if="item.audit_remark != ''">处理备注：{{item.audit_remark}}</span>
			</div>
			<i v-if="index < list.length - 1" class="el-icon-bottom"/>
		</div>
	</div>
</template>

<script>
	export default{
		props:{
			list:{
				type:Array
			}
		}
	}
</script>

<style scoped>
	.col{
		display: flex;
		flex-direction: column;
		margin: 20px 0 0 20px;
	}
	.row{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.el-icon-user{
		font-size: 22px;
		color: #d8d8d8;
		margin-right: 20px;
	}
	
	.el-icon-bottom{
		font-size: 22px;
		color: #d8d8d8;
		margin-top: 10px;
		margin-bottom: -5px;
	}
</style>